import { LandingHeader } from "./landingPage";

export default function AboutUs() {
  return null;
  return (
    <>
      <LandingHeader />
      <div className="text-center p-7">
        <h4 className="mb-5 text-center text-[40px] font-bold">About Us</h4>
        <div className=" md:w-[70%] md:mx-auto">
          <p className="text-lg">Welcome to Nagar Parishad Wanadongri</p>
          <p className="text-lg text-justify">
            Nagar Parishad Wanadondri was established on 26 October 2016 under
            section 3 of Maharashtra Municipal Councils, Nagar Panchayats and
            Industrial Townships Act 1965. Wanadongri city is situated near Vena
            river and it is 20 km away from Nagpur city. Total area of Nagar
            Parishad Wanadongri is 12.07 sq. km. The key responsibility for
            providing basic urban services to the citizen of Wanadongri lies
            with the Nagar Parishad Wanadongri. These services include water
            supply, sewerage, waste management, slum improvement, land use
            planning, construction and maintenance of roads, street lighting,
            maintenance of parks and gardens, providing primary health and
            education facilities, etc. The Chief Officer is the administrative
            head of the Nagar Parishad who is assisted by various department
            heads and other officers. The current Chief Officer of Nagar
            Parishad Wanadongri is <b>Mr. Bharat Nandanwar</b>. Nagar Parishad
            Wanadongri co-ordinates with various other government organizations
            like MSRTC, the Traffic Police, MPCB, etc. for delivering these
            basic urban services.
          </p>
        </div>
        <h4 className="mb-5 text-center text-[40px] font-bold mt-10">
          Contact Us
        </h4>
        <div className=" md:w-[70%] md:mx-auto mb-10">
          <h6 className="text-xl text-neutral-400">
            <i className="fa fa-building text-neutral-400"></i>
            Address
          </h6>
          <p className="text-lg mb-4">
            <a href="https://maps.app.goo.gl/9wx6p8T55yNb8qEN8" target="_blank">
              Nagar Parishad Wanadongri, Nagar Parishad Building, Wanadongri,
              Nagpur, Maharashtra - 441110
            </a>
          </p>
          <h6 className="text-xl text-neutral-400">
            <i className="fa fa-envelope text-neutral-400"></i>
            Email
          </h6>
          <p className="text-lg text-muted">
            <a href="mailto:mcwanadongari2016@gmail.com">
              mcwanadongari2016@gmail.com
            </a>
          </p>
        </div>

        <a
          href="/terms_and_conditions.pdf"
          target="_blank"
          className="px-4 py-3 focus:text-white font-semibold hover:text-white focus:border-none bg-primary rounded text-white"
        >
          <i className="fa fa-link text-white"></i>
          Terms & Conditions for Payments
        </a>
      </div>
    </>
  );
}
